import Rollbar from 'rollbar';
import { App, Plugin } from 'vue';

const GlobalsPlugin: Plugin = {
	install: (app: App<Element>): void => {
		const rollbarConfig = {
			accessToken: '53284b68f71a44e2b46fa9b1698bb263',
			captureUncaught: false,
			captureUnhandledRejections: false,
			payload: {
				environment: CONFIG.STAGE,
			},
		};

		const rollbar = new Rollbar(rollbarConfig);

		app.config.errorHandler = (error: any): void => {
			if (rollbar === null) {
				return;
			}

			if (CONFIG.STAGE === 'prd') {
				rollbar.error(error);
			}

			throw error;
		};
	},
};

export { GlobalsPlugin };
